
  import {Component, Prop, Vue} from "vue-property-decorator";
  import {PayrollAssignDto, PayrollOfPartnerDto} from "@/api/appService";

  @Component({name:'SalaryDetail'})
  export default class SalaryDetail extends Vue{

    @Prop()
    detail:any;

    show:boolean = false;

    handleClose(){
      this.show = false;
    }

  }
